import * as React from 'react';
import {DisplayObjectList} from '../../components/DisplayObjectList';
import {ReelsMatrix} from '../../components/ReelsMatrix';
import {ButtonWithTitle} from '../../components/ButtonWithTitle';
import {CheatPluginView} from '../../CheatPluginView';
import {CheatMatrixController} from './CheatMatrixController';
import {Fragment} from 'react';

export class CheatMatrixView extends CheatPluginView<CheatMatrixController> {
    public componentDidMount(): void {
        const {store} = this.controller;

        store.on('loading', () => this.forceUpdate(), this);
    }

    public componentWillUnmount(): void {
        this.controller.store.off('loading', this);
    }

    protected onReject(): void {
        this.controller.rejectMatrixFilter();
        this.forceUpdate();
    }

    protected onApply(): void {
        this.controller.addActionMatrixFilter();
    }

    protected onClickSymbol(sym: number, reelIndex: number, rowIndex: number): void {
        this.controller.nextSymbol(sym, reelIndex, rowIndex);
        this.forceUpdate();
    }

    protected onRightClickSymbol(sym: number, reelIndex: number, rowIndex: number): void {
        this.controller.previousSymbol(sym, reelIndex, rowIndex);
        this.forceUpdate();
    }

    public render(): JSX.Element {
        const {matrix = [], symbolsTextures} = this.controller;
        const {loading} = this.controller.store.data;

        if (loading) {
            return <Fragment />;
        }

        return (
            <DisplayObjectList y={80} gapBetweenChildren={100}>
                <ReelsMatrix
                    onClickSymbol={this.onClickSymbol.bind(this)}
                    onRightClickSymbol={this.onRightClickSymbol.bind(this)}
                    matrix={matrix} symbolsTexturesByID={symbolsTextures}
                />
                <DisplayObjectList direction={'row'} gapBetweenChildren={20}>
                    <ButtonWithTitle title={'Reject'} fontSize={80} onClick={this.onReject.bind(this)} height={150} width={400} />
                    <ButtonWithTitle title={'Apply'} fontSize={80} onClick={this.onApply.bind(this)} height={150} width={400} />
                </DisplayObjectList>
            </DisplayObjectList>
        );
    }
}
